module.exports = __webpack_public_path__ + "img/api-opportunities.ad937848.svg";